import React from "react";
import { ScaleLoader } from "react-spinners";

const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10%",
      }}
    >
      <ScaleLoader color={"#395970"} className="spinner" size={300} />
    </div>
  );
};

export default Loading;
